// Shared BroadcastChannel so all open admin tabs can sync messaging events (e.g. conv_read)
const messagingBroadcast = new BroadcastChannel("admin_messaging");
export default messagingBroadcast;
